/**
 *
 *
 * Usage:
 *
 *   data-sw-modal-trigger
 *   data-sw-modal-trigger-endpoint=<url of html fragment>
 */

var sw = require('./../../lib/sw');
var $ = require('./../sw-jquery');
var fragments = require('./../../lib/sw-fragments');

$(document).ready(function() {

  $('body').on('click', '[data-sw-modal-trigger]', function(e) {
    e.preventDefault();

    var $el = $(this);

    if($el.hasClass('disabled')) {
      return;
    }

    var options = $el.swDataParams('swModalTrigger');
    var url = fragments.getHref('generic', {endpoint: options.swModalTriggerEndpoint});

    $.fancybox({
      href        : url,
      type        : 'ajax',
      autoSize    : false,
      autoResize  : false,
      fitToView   : false,
      autoCenter  : true,
      leftRatio   : 0,
      padding     : 0,
      width       : 'auto',
      height      : 'auto',
      afterShow: function() {
        var $wrapper = $('[data-sw-model-scale-modal]');
        sw.trigger('modal-loaded', $wrapper);
      },
      keys: {
        close: [
          27
        ]
      }
    });

  });

});


